export default "//static.tradera.net/touchweb/static/output/images/qr-code-appstore.481069fc.svg";